// import _ from "lodash";
import 'lodash.combinations';

import roundLodash from 'lodash/round';
import groupBy from 'lodash/groupBy';
import find from 'lodash/find';
import minBy from 'lodash/minBy';
import maxBy from 'lodash/maxBy';
import sumBy from 'lodash/sumBy';
import filter from 'lodash/filter';
import forEachLodash from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';
import orderBy from 'lodash/orderBy';
import countBy from 'lodash/countBy';

// const isCombinable = async (bet, combinableMarkets = []) => {
//
//
//     try {
//
//         if (combinableMarkets.length === 0) {
//             console.log('[DEBUG] THERE ARE NOT MARKETS COMBINABLE')
//             return false
//         }
//
//         const groupByEventSource = await groupBy(bet.odds, 'event_source');
//
//         for (const obj of Object.values(groupByEventSource)) {
//
//             // console.log('obj is: ')
//             // console.log(obj)
//
//             const numberOfOutcomesForSingleEvent = obj.length
//
//             if (numberOfOutcomesForSingleEvent > 1) { // if there is a single outcome for that event dont consider other logic and go forward else need check  some things...
//
//
//                 const groupedByMarketUniqueId = await groupBy(obj, 'id_market');
//                 // console.log('groupedByMarketUniqueId')
//                 // console.log(groupedByMarketUniqueId)
//
//                 for (const outcome of Object.keys(groupedByMarketUniqueId)) {
//
//                     // console.log('outcome')
//                     // console.log(outcome)
//
//                     const length = groupedByMarketUniqueId[outcome].length
//
//                     // console.log('groupedByMarketUniqueId[outcome]')
//                     // console.log(groupedByMarketUniqueId[outcome])
//
//                     if (length > 1) { // there are more outcomes alias equals for a single event...
//                         console.log('[DEBUG] THERE ARE MORE OUTCOMES ALIAS EQUALS FOR A SINGLE EVENT')
//                         return false
//                     }
//                 }
//
//                 const groupByEventSourceAndMarketId = await groupBy(obj, 'id_market');
//
//                 const arrayOfOddsForThatEvent = []
//
//                 for (const el of Object.values(groupByEventSourceAndMarketId)) {
//
//                     for (const element of el) {
//                         arrayOfOddsForThatEvent.push(element)
//                     }
//
//                     const numberOfOutcomesForThisEventMarket = Object.values(el).length
//
//                     if (numberOfOutcomesForThisEventMarket > 1) {
//                         console.log('[DEBUG] CANT PLAY 2 OR MORE OUTCOMES FOR THE SAME MARKET FOR THE SAME EVENT')
//                         return false // cant play 2 or more outcome for the same market for the same event
//                     } else {
//
//                         const tournamentForThisEvent = obj[0].tournament.id.toString();
//
//                         const foundGroupRule = combinableMarkets.find(el => {
//                             return el.tournamentId === tournamentForThisEvent
//                         })
//
//                         const marketsCombinable = (foundGroupRule != null && foundGroupRule.markets != null) ? foundGroupRule.markets : []
//
//                         for (const el of obj) {
//
//                             const betMarketId = el.id_market.toString();
//
//                             if (!marketsCombinable.includes(betMarketId)) {
//                                 console.log('[DEBUG] NOT ALL THE MARKETS ARE COMBINABLE!')
//                                 return false
//                             }
//                         }
//                     }
//                 }
//
//                 for (let i = 0; i < arrayOfOddsForThatEvent.length; i++) { // TODO this is a very dirty solution for avoid play 2 outcomes of the same player
//                     const currentElement = arrayOfOddsForThatEvent[i];
//
//                     for (let j = 0; j < arrayOfOddsForThatEvent.length; j++) {
//                         if (i === j) continue; // Skip comparing to itself
//
//                         const otherElement = arrayOfOddsForThatEvent[j];
//                         const currentOutcomeAliasSplitted = currentElement.outcome_alias.split(" ");
//
//                         const marketUniqueIdWIthoutMarketId = otherElement.market_unique_id.split("#");
//
//                         let marketSpecifierToTest = null
//                         if (marketUniqueIdWIthoutMarketId.length > 0) {
//
//                             marketSpecifierToTest = marketUniqueIdWIthoutMarketId[1]
//
//                         }
//
//                         let splittedMarketSpecifierToTest = null
//
//                         let arrayToTest = []
//
//                         if (marketSpecifierToTest) {
//
//                             // ho beccato un market che ha lo specifier e quindi potrebbe essere uno coi giocatori, anche se potrebbe essere un under/over 3.5 pfff...
//
//                             splittedMarketSpecifierToTest = marketSpecifierToTest.split(" ");
//
//                             for (let i = 0; i < splittedMarketSpecifierToTest.length; i++) {
//
//                                 arrayToTest.push(accentsTidy(splittedMarketSpecifierToTest[i]))
//                                 if (i == 2) {
//                                     break
//                                 }
//                             }
//
//                         }
//
//                         arrayToTest = arrayToTest.filter(el => {
//                             return el != 'SEGNA'
//                         })
//
//                         arrayToTest = arrayToTest.map(el => {
//                             return el.toLowerCase()
//                         })
//
//                         console.log('****************************************** STEP 1 ********************************************************************')
//                         console.log('string test 1')
//                         console.log(arrayToTest);
//
//                         const isSimilar = currentOutcomeAliasSplitted.some(part => {
//
//                             part = accentsTidy(part);
//                             console.log('test similar');
//                             console.log(part);
//
//                             return arrayToTest.includes(part.toLowerCase())
//                         });
//
//                         if (isSimilar) {
//                             console.log('[DEBUG] FAIL TEST ON IS_SIMILAR')
//                             return false
//                         }
//
//                         // console.log('****************************************** STEP 2 ********************************************************************')
//                         //
//                         // console.log('string test 2')
//                         // console.log(otherElement.market_unique_id.toLowerCase())
//                         //
//                         // const isSimilarInverse3 = currentOutcomeAliasSplitted.some(part => {
//                         //
//                         //     part = accentsTidy(part);
//                         //     console.log('part step 2');
//                         //     console.log(part);
//                         //
//                         //     return accentsTidy(otherElement.market_unique_id.toLowerCase()).includes(part.toLowerCase())
//                         // });
//                         //
//                         // if (isSimilarInverse3) {
//                         //     console.log('[DEBUG] FAIL TEST ON IS_SIMILAR_3')
//                         //     console.timeEnd('isCombinable')
//                         //     return false
//                         // }
//
//                         if (marketSpecifierToTest) {
//
//                             marketSpecifierToTest = accentsTidy(marketSpecifierToTest.toLowerCase());
//
//                             console.log('****************************************** STEP 3 ********************************************************************')
//                             console.log('string test 3')
//                             console.log(marketSpecifierToTest)
//
//                             const isSimilarInverse = currentOutcomeAliasSplitted.some(part => {
//
//                                 part = accentsTidy(part);
//                                 // console.log('part step 3');
//                                 // console.log(part);
//
//                                 return part.toLowerCase().includes(marketSpecifierToTest)
//                             });
//
//                             if (isSimilarInverse) {
//                                 console.log('[DEBUG] FAIL TEST ON IS_SIMILAR_INVERSE')
//                                 return false
//                             }
//                             //
//                             console.log('****************************************** STEP 4 ********************************************************************')
//                             console.log('string test 4')
//                             console.log(marketSpecifierToTest)
//
//
//                             const isSimilarInverse2 = currentOutcomeAliasSplitted.some(part => {
//
//                                 part = accentsTidy(part);
//                                 // console.log('part step 4');
//                                 // console.log(part);
//                                 return marketSpecifierToTest.includes(part)
//                             });
//
//                             if (isSimilarInverse2) {
//                                 console.log('[DEBUG] FAIL TEST ON IS_SIMILAR_INVERSE 2')
//                                 return false
//                             }
//                         } else {
//
//                             console.log('****************************************** STEP 5 ********************************************************************')
//                             console.log('string test 5')
//                             console.log(currentOutcomeAliasSplitted)
//
//
//                             console.log('other element')
//                             console.log(otherElement)
//
//                             const outcomeNameOther = accentsTidy(otherElement.outcome_alias)
//
//                             console.log('outcomeNameOther')
//                             console.log(outcomeNameOther)
//
//                             const isSimilarOutcome = currentOutcomeAliasSplitted.some(part => {
//                                 part = accentsTidy(part);
//                                 console.log('part step 5');
//                                 console.log(part);
//                                 return outcomeNameOther.includes(part)
//                             });
//
//                             if (isSimilarOutcome) {
//                                 console.log('[DEBUG] FAIL TEST ON STEP 5')
//                                 return false
//                             }
//                         }
//
//
//                         // test
//                         //
//                         // const myTest = "Griezmann".toLowerCase().includes("8767195734#primo marcatore griezmann a. o il suo sostituto incl. t.s.".toLowerCase())
//                         // console.log('il mio test')
//                         // console.log(myTest)
//                         //
//                         // const myTest2 = "8767195734#primo marcatore griezmann a. o il suo sostituto incl. t.s.".toLowerCase().includes("Griezmann".toLowerCase())
//                         // console.log('il mio test2')
//                         // console.log(myTest2)
//
//                     }
//                 }
//             }
//         }
//
//         return true;
//
//
//     } catch (e) {
//         console.log(e);
//         return false
//     }
//
// }

const isCombinable = async (bet, combinableMarkets = []) => {
  try {
    if (combinableMarkets.length === 0) {
      console.log('[DEBUG] THERE ARE NOT MARKETS COMBINABLE');
      return false;
    }

    const groupByEventSource = await groupBy(bet.odds, 'event_source');

    for (const obj of Object.values(groupByEventSource)) {
      const numberOfOutcomesForSingleEvent = obj.length;

      if (numberOfOutcomesForSingleEvent > 1) {
        // if there is a single outcome for that event dont consider other logic and go forward else need check  some things...

        const groupByEventSourceAndMarketId = await groupBy(obj, 'id_market');

        const arrayOfOddsForThatEvent = [];

        for (const el of Object.values(groupByEventSourceAndMarketId)) {
          for (const element of el) {
            arrayOfOddsForThatEvent.push(element);
          }

          const tournamentForThisEvent = obj[0].tournament.id.toString();

          const foundGroupRule = combinableMarkets.find(el => {
            return el.tournamentId === tournamentForThisEvent;
          });

          const marketsCombinable =
            foundGroupRule != null && foundGroupRule.markets != null
              ? foundGroupRule.markets
              : [];

          for (const el of obj) {
            const betMarketId = el.id_market.toString();

            if (!marketsCombinable.includes(betMarketId)) {
              console.log('[DEBUG] NOT ALL THE MARKETS ARE COMBINABLE!');
              return false;
            }
          }
        }

        for (let i = 0; i < arrayOfOddsForThatEvent.length; i++) {
          // TODO this is a very dirty solution for avoid play 2 outcomes of the same player
          const currentElement = arrayOfOddsForThatEvent[i];

          for (let j = 0; j < arrayOfOddsForThatEvent.length; j++) {
            if (i === j) continue; // Skip comparing to itself

            const otherElement = arrayOfOddsForThatEvent[j];
            const currentOutcomeAliasSplitted =
              currentElement.outcome_alias.split(' ');

            const marketUniqueIdWIthoutMarketId =
              otherElement.market_unique_id.split('#');

            let marketSpecifierToTest = null;
            if (marketUniqueIdWIthoutMarketId.length > 0) {
              marketSpecifierToTest = marketUniqueIdWIthoutMarketId[1];
            }

            let splittedMarketSpecifierToTest = null;

            let arrayToTest = [];

            if (marketSpecifierToTest) {
              // ho beccato un market che ha lo specifier e quindi potrebbe essere uno coi giocatori, anche se potrebbe essere un under/over 3.5 pfff...

              splittedMarketSpecifierToTest = marketSpecifierToTest.split(' ');

              for (let i = 0; i < splittedMarketSpecifierToTest.length; i++) {
                arrayToTest.push(accentsTidy(splittedMarketSpecifierToTest[i]));
                if (i == 2) {
                  break;
                }
              }
            }

            arrayToTest = arrayToTest.filter(el => {
              return el != 'SEGNA';
            });

            arrayToTest = arrayToTest.map(el => {
              return el.toLowerCase();
            });

            // console.log('****************************************** STEP 1 ********************************************************************')
            // console.log('string test 1')
            // console.log(arrayToTest);

            const isSimilar = currentOutcomeAliasSplitted.some(part => {
              part = accentsTidy(part);
              // console.log('test similar');
              // console.log(part);
              return arrayToTest.includes(part.toLowerCase());
            });

            if (isSimilar) {
              console.log('[DEBUG] FAIL TEST ON IS_SIMILAR');
              return false;
            }

            // console.log('****************************************** STEP 2 ********************************************************************')
            //
            // console.log('string test 2')
            // console.log(otherElement.market_unique_id.toLowerCase())
            //
            // const isSimilarInverse3 = currentOutcomeAliasSplitted.some(part => {
            //
            //     part = accentsTidy(part);
            //     console.log('part step 2');
            //     console.log(part);
            //
            //     return accentsTidy(otherElement.market_unique_id.toLowerCase()).includes(part.toLowerCase())
            // });
            //
            // if (isSimilarInverse3) {
            //     console.log('[DEBUG] FAIL TEST ON IS_SIMILAR_3')
            //     console.timeEnd('isCombinable')
            //     return false
            // }

            if (marketSpecifierToTest) {
              marketSpecifierToTest = accentsTidy(
                marketSpecifierToTest.toLowerCase()
              );

              // console.log('****************************************** STEP 3 ********************************************************************')
              // console.log('string test 3')
              // console.log(marketSpecifierToTest)

              const isSimilarInverse = currentOutcomeAliasSplitted.some(
                part => {
                  part = accentsTidy(part);
                  // console.log('part step 3');
                  // console.log(part);

                  return part.toLowerCase().includes(marketSpecifierToTest);
                }
              );

              if (isSimilarInverse) {
                console.log('[DEBUG] FAIL TEST ON IS_SIMILAR_INVERSE');
                return false;
              }
              //
              // console.log('****************************************** STEP 4 ********************************************************************')
              // console.log('string test 4')
              // console.log(marketSpecifierToTest)

              const isSimilarInverse2 = currentOutcomeAliasSplitted.some(
                part => {
                  part = accentsTidy(part);
                  // console.log('part step 4');
                  // console.log(part);
                  return marketSpecifierToTest.includes(part);
                }
              );

              if (isSimilarInverse2) {
                //console.log('[DEBUG] FAIL TEST ON IS_SIMILAR_INVERSE 2')
                return false;
              }
            } else {
              // console.log('****************************************** STEP 5 ********************************************************************')
              // console.log('string test 5')
              // console.log(currentOutcomeAliasSplitted)
              //
              //
              // console.log('other element')
              // console.log(otherElement)

              const outcomeNameOther = accentsTidy(otherElement.outcome_alias);

              // console.log('outcomeNameOther')
              // console.log(outcomeNameOther)

              const isSimilarOutcome = currentOutcomeAliasSplitted.some(
                part => {
                  part = accentsTidy(part);
                  // console.log('part step 5');
                  // console.log(part);
                  return outcomeNameOther.includes(part);
                }
              );

              if (isSimilarOutcome) {
                // console.log('[DEBUG] FAIL TEST ON STEP 5')
                return false;
              }
            }

            // test
            //
            // const myTest = "Griezmann".toLowerCase().includes("8767195734#primo marcatore griezmann a. o il suo sostituto incl. t.s.".toLowerCase())
            // console.log('il mio test')
            // console.log(myTest)
            //
            // const myTest2 = "8767195734#primo marcatore griezmann a. o il suo sostituto incl. t.s.".toLowerCase().includes("Griezmann".toLowerCase())
            // console.log('il mio test2')
            // console.log(myTest2)
          }
        }
      }
    }

    return true;
  } catch (e) {
    console.log(e);
    return false;
  }
};

const accentsTidy = function (s) {
  let r = s.toLowerCase();
  // r = r.replace(new RegExp("\\s", 'g'), "");
  r = r.replace(new RegExp('[àáâãäå]', 'g'), 'a');
  r = r.replace(new RegExp('æ', 'g'), 'ae');
  r = r.replace(new RegExp('ç', 'g'), 'c');
  r = r.replace(new RegExp('[èéêë]', 'g'), 'e');
  r = r.replace(new RegExp('[ìíîï]', 'g'), 'i');
  r = r.replace(new RegExp('ñ', 'g'), 'n');
  r = r.replace(new RegExp('[òóôõö]', 'g'), 'o');
  r = r.replace(new RegExp('œ', 'g'), 'oe');
  r = r.replace(new RegExp('[ùúûü]', 'g'), 'u');
  r = r.replace(new RegExp('[ýÿ]', 'g'), 'y');
  r = r.replace(new RegExp('\\W', 'g'), '');
  return r;
};

async function getCartType(bet, combinableMarkets = []) {
  return new Promise(async (resolve, reject) => {
    //console.log('BET ARRIVATA CON TYPE:  ' +  bet.type)
    if (bet.odds.length <= 1) {
      resolve('single');
    } else {
      const groupByEventSource = await groupBy(bet.odds, 'event_source');

      if (
        bet.type == 'integral' &&
        Object.keys(groupByEventSource).length < bet.odds.length
      ) {
        //console.log('RISOLVE IL TIPO in -> integral')
        resolve('integral');
      } else if (
        Object.keys(groupByEventSource).length < bet.odds.length &&
        (await isCombinable(bet, combinableMarkets))
      ) {
        //console.log('RISOLVE IL TIPO in -> multiple')
        resolve('multiple');
      } else if (Object.keys(groupByEventSource).length < bet.odds.length) {
        //console.log('RISOLVE IL TIPO in -> integral')
        resolve('integral');
      } else if (bet.type != 'system') {
        //console.log('RISOLVE IL TIPO in -> multiple')
        resolve('multiple');
      } else {
        //console.log('RISOLVE IL TIPO in -> system')
        resolve('system');
      }
    }
  });
}

async function getCartContext(bet) {
  console.log('getCartContext', bet);
  return new Promise(async (resolve, reject) => {
    const odds = JSON.parse(JSON.stringify(bet.odds));
    const grouped_odds = groupBy(odds, 'type');
    const types = Object.keys(grouped_odds);

    if (types.length > 1) {
      resolve('mixed');
    } else {
      resolve(types[0]);
    }
  });
}

async function getOddsTotal(odds) {
  return new Promise(async (resolve, reject) => {
    let odds_total = 1.0;

    for await (const odd of odds) {
      odds_total = odds_total * +odd.outcome_odd_value;
    }

    resolve(roundLodash(odds_total, 2));
  });
}

async function getBonus(cartSettings, bet, multiplicity, bonusRules) {
  return new Promise(async (resolve, reject) => {
    // Check the rule and select the percentage
    // Return percentage and odds total where the bonus is valid

    const result = {
      bonusPercentage: 0.0,
      oddsTotal: 1.0
    };

    const check_antepost = find(bet.odds, { type: 'antepost' });

    if (check_antepost != undefined) {
      resolve(result);
    } else {
      // Prematch -> 0 - Live || Mixed -> 1
      const context = bet.context == 'prematch' ? 0 : 1;
      const multi = multiplicity.toFixed(0);

      for (const odd of bet.odds) {
        result.oddsTotal = result.oddsTotal * +odd.outcome_odd_value;
      }

      let valid = 0;
      let not_valid = 0;

      for (let i = Number(multi); i > 0; i--) {
        // console.log("ciclo:",i);
        const rule = find(bonusRules, {
          multiplicity: i.toString(),
          context: context
        });

        if (!isEmpty(rule)) {
          valid = 0;
          not_valid = 0;
          for (const odd of bet.odds) {
            if (+odd.outcome_odd_value < +rule.minOddValue) {
              not_valid++;
            } else {
              valid++;
            }
          }

          if (valid >= i) {
            result.percentage = result.oddsTotal > 1 ? +rule.percentage : 0.0;
            resolve(result);
            break;
          }
        } else {
          result.percentage = 0.0;
          resolve(result);
        }
      }
      if (valid == 0) {
        result.percentage = 0.0;
        resolve(result);
      }
    }
  });
}

// Function to calculate bonus only on valid odds

// async function getBonus(cartSettings, bet, multiplicity, bonusRules) {
//     return new Promise(async (resolve, reject) => {
//
//         // Check the rule and select the percentage
//         // Return percentage and odds total where the bonus is valid
//
//         var result = {
//             bonusPercentage : 0.00,
//             oddsTotal : 1.00
//         }
//
//         var check_antepost = find(bet.odds, {'type':'antepost'})
//
//         if(check_antepost != undefined){
//
//             resolve(result)
//
//         }else {
//
//             // Prematch -> 0 - Live || Mixed -> 1
//             var context = (bet.context == 'prematch') ? 0 : 1
//             var multi = multiplicity.toFixed(0)
//
//             var rule = find(bonusRules, {'multiplicity': multi, 'context': context})
//             if(!isEmpty(rule)){
//
//                 for(let odd of bet.odds){
//                     if (+odd.outcome_odd_value >= +rule.minOddValue) {
//                         result.oddsTotal = result.oddsTotal*(+odd.outcome_odd_value)
//                     }
//                 }
//
//                 result.percentage = (result.oddsTotal > 1)  ? +rule.percentage : 0.00
//                 resolve(result)
//
//             }else {
//
//                 resolve(result)
//
//             }
//         }
//     })
// }

async function resetBetAmount(bet, oldType, minAmount) {
  return new Promise(async (resolve, reject) => {
    if (
      bet.type == oldType ||
      ((oldType == 'single' || oldType == 'multiple') &&
        (bet.type == 'single' || bet.type == 'multiple'))
    ) {
      resolve(bet);
    } else {
      bet._multiple_detail.amount = 0.0;
      bet._integral_detail.amount = 0.0;
      bet._system_detail.amount_system = 0.0;
      bet._system_detail.amount_system_equal = null;
      bet._system_detail.amount_system_to_divide = null;
      bet._system_detail.fixed_bases = [];

      if (bet.type == 'simple' || bet.type == 'multiple') {
        bet._multiple_detail.amount = minAmount;
      } else if (bet.type == 'integral') {
        bet._integral_detail.amount = minAmount;
      }

      resolve(bet);
    }
  });
}

async function resetBetIntegralOrSystem(bet) {
  if (bet._integral_detail) {
    bet._integral_detail.amount = 1.0;
    bet._integral_detail.bonus_max = 0.0;
    bet._integral_detail.bonus_min = 0.0;
    bet._integral_detail.combinations = 0;
    bet._integral_detail.multiplicity = 1;
    bet._integral_detail.odds_total_max = 0.0;
    bet._integral_detail.odds_total_min = 0.0;
    bet._integral_detail.profit_max = 0.0;
    bet._integral_detail.profit_min = 0.0;
    bet._integral_detail.winning_max = 0.0;
    bet._integral_detail.winning_min = 0.0;
    bet._integral_detail.winning_total_max = 0.0;
    bet._integral_detail.winning_total_min = 0.0;
  }

  if (bet._system_detail) {
    bet._system_detail.amount_system = 0.0;
    bet._system_detail.amount_system_equal = null;
    bet._system_detail.amount_system_to_divide = null;
    bet._system_detail.bonus_max = 0.0;
    bet._system_detail.bonus_min = 0.0;
    bet._system_detail.combinations = 0;
    // bet._system_detail.multiplicity = 1
    // bet._system_detail.odds_total_max = 0.00
    // bet._system_detail.odds_total_min = 0.00
    // bet._system_detail.profit_max = 0.00
    // bet._system_detail.profit_min = 0.00
    bet._system_detail.winning_max = 0.0;
    bet._system_detail.winning_min = 0.0;
    bet._system_detail.winning_total_max = 0.0;
    bet._system_detail.winning_total_min = 0.0;
  }
}

// Integral Functions
async function getOddsTotalMinMax(groupOdds) {
  return new Promise(async (resolve, reject) => {
    let odds_total_min = 1.0;
    let odds_total_max = 1.0;

    const odds_min = [];
    const odds_max = [];

    forEachLodash(groupOdds, odd => {
      if (odd.length == 1) {
        odds_total_min = odds_total_min * +odd[0].outcome_odd_value;
        odds_total_max = odds_total_max * +odd[0].outcome_odd_value;

        odds_min.push(+odd[0].outcome_odd_value);
        odds_max.push(+odd[0].outcome_odd_value);
      } else {
        const min = minBy(odd, function (o) {
          return o.outcome_odd_value_for_order;
        });
        const max = maxBy(odd, function (o) {
          return o.outcome_odd_value_for_order;
        });

        odds_total_min = odds_total_min * +min.outcome_odd_value;
        odds_total_max = odds_total_max * +max.outcome_odd_value;

        odds_min.push(+min.outcome_odd_value);
        odds_max.push(+max.outcome_odd_value);
      }
    });

    resolve({
      odds_min: odds_min,
      odds_max: odds_max,
      odds_total_min: roundLodash(odds_total_min, 2),
      odds_total_max: roundLodash(odds_total_max, 2)
    });
  });
}

async function getIntegralParts(groupOdds) {
  return new Promise(async (resolve, reject) => {
    const oddsGrouped = JSON.parse(JSON.stringify(groupOdds));

    // Remove Info
    forEachLodash(oddsGrouped, clean => {
      if (clean.length == 1) {
        delete clean[0].category;
        delete clean[0].sport;
        delete clean[0].tournament;
      } else {
        forEachLodash(clean, cl => {
          delete cl.category;
          delete cl.sport;
          delete cl.tournament;
        });
      }
    });

    let combinations = 1;
    const combinations_arrays = [];

    forEachLodash(groupOdds, odd => {
      combinations *= odd.length;
      combinations_arrays.push(odd);
    });

    // Switch Off for performance
    const result = await cartesianProduct(...combinations_arrays);
    // const result = []

    resolve({
      combinations: combinations,
      integralParts: result
    });
  });
}

async function refactorIntegralParts(
  comboArray,
  amount,
  cartSettings,
  bonusRules,
  multiplicity,
  context
) {
  return new Promise(async (resolve, reject) => {
    const refactoredComboArray = [];
    const combinations = comboArray.length;

    await Promise.all(
      comboArray.map(async betOdds => {
        const bet = {};
        bet.amount = amount;
        bet.context = context;

        bet.odds = betOdds;

        bet.odds_total = await getOddsTotal(betOdds);
        bet.multiplicity = betOdds.length;

        bet.winning = roundLodash(bet.amount * bet.odds_total, 2);

        const bonusDetail = await getBonus(
          cartSettings,
          bet,
          bet.multiplicity,
          bonusRules
        );

        if (bonusDetail.percentage > 0.0 && bonusDetail.oddsTotal > 0.0) {
          bet.bonus_percentage = +bonusDetail.percentage;
          bet.bonus = roundLodash(
            (bonusDetail.oddsTotal / 100) *
              +bonusDetail.percentage *
              bet.amount,
            2
          );
        } else {
          bet.bonus_percentage = 0.0;
          bet.bonus = 0.0;
        }

        bet.winning_total = roundLodash(bet.winning + bet.bonus, 2);
        bet.profit = roundLodash(bet.winning_total - bet.amount, 2);

        // Switch off for Performance
        bet.odds = [];

        refactoredComboArray.push(bet);
      })
    );

    resolve(refactoredComboArray);
  });
}

async function cartesianProduct(...arr) {
  return arr.reduce(
    (acc, val) => {
      return acc
        .map(el => {
          return val.map(element => {
            return el.concat([element]);
          });
        })
        .reduce((acc, val) => acc.concat(val), []);
    },
    [[]]
  );
}

// System Functions

async function getSystemComboDetail(
  odds,
  system_combo_detail,
  minAmount,
  bases
) {
  return new Promise(async (resolve, reject) => {
    const new_system_combo = [];
    let combinations = 0;

    // Remove Info
    const oddsArray = JSON.parse(JSON.stringify(odds));
    forEachLodash(oddsArray, odd => {
      delete odd.category;
      delete odd.sport;
      delete odd.tournament;
    });

    for (let i = 0; i < oddsArray.length; i++) {
      const multiplicity = i + 1;

      if (multiplicity - bases.length < 1) {
        combinations += 0;
        new_system_combo[i] = {
          amount: 0.0,
          checked: false,
          multiplicity: multiplicity,
          num_combo: 0,
          combinationsOdds: [],
          show: false
        };

        continue;
      }

      const num_combo = await calcCombin(
        oddsArray.length - bases.length,
        multiplicity - bases.length
      );

      if (bases.length == 0) {
        var combinationsOdds = await _.combinations(oddsArray, multiplicity);
        // var combinationsOdds = []
      } else {
        var combinationsOdds = await getComboWithBased(
          oddsArray,
          multiplicity,
          bases
        );
        // var combinationsOdds = []
      }

      if (system_combo_detail[i] != undefined) {
        if (
          system_combo_detail[i].checked &&
          system_combo_detail[i].amount == 0.0
        ) {
          system_combo_detail[i].amount = minAmount;
        }

        if (
          system_combo_detail[i].amount > 0 ||
          system_combo_detail[i].checked
        ) {
          combinations += num_combo;
        }

        new_system_combo[i] = {
          amount: system_combo_detail[i].checked
            ? system_combo_detail[i].amount
            : 0.0,
          checked: system_combo_detail[i].checked,
          multiplicity: multiplicity,
          num_combo: num_combo,
          combinationsOdds: combinationsOdds,
          show: system_combo_detail[i].checked && system_combo_detail[i].show
        };
      } else {
        new_system_combo[i] = {
          amount: 0.0,
          checked: false,
          multiplicity: multiplicity,
          num_combo: num_combo,
          combinationsOdds: combinationsOdds,
          show: false
        };
      }
    }

    resolve({
      combinations: combinations,
      system_combo: new_system_combo
    });
  });
}

async function getComboWithBased(oddsArray, multiplicity, bases) {
  return new Promise(async (resolve, reject) => {
    const variablesOdds = [];
    const fixedOdds = [];

    for (const odd of oddsArray) {
      if (!bases.includes(odd.unique_id)) {
        variablesOdds.push(odd);
      } else {
        fixedOdds.push(odd);
      }
    }

    if (multiplicity - bases.length > 0) {
      const combo = await _.combinations(
        variablesOdds,
        multiplicity - bases.length
      );

      await Promise.all(
        combo.map(async system_combo => {
          Array.prototype.push.apply(system_combo, fixedOdds);
        })
      );

      resolve(combo);
    } else {
      resolve([]);
    }
  });
}

async function refactorSystemBet(bet, cartSettings, bonusRules) {
  return new Promise(async (resolve, reject) => {
    const promise = [];
    forEachLodash(bet.system_parts, system_combo => {
      system_combo.context = bet.context;
      promise.push(refactorSystemCombo(system_combo, cartSettings, bonusRules));
    });

    Promise.all(promise).then(result => {
      const ordered = orderBy(result, ['multiplicity']);
      bet.system_parts = ordered;
      resolve(bet);
    });
  });
}

async function refactorSystemCombo(system_combo, cartSettings, bonusRules) {
  return new Promise(async (resolve, reject) => {
    if (system_combo != undefined) {
      const systemRefactored = await refactorSystemParts(
        system_combo.combinationsOdds,
        system_combo.amount,
        cartSettings,
        bonusRules,
        system_combo.multiplicity,
        system_combo.context
      );

      // Switch off performance
      // system_combo.bets = systemRefactored.refactoredComboArray
      system_combo.bets = [];

      system_combo.totalAmount = systemRefactored.totalAmount;
      system_combo.winning_min = systemRefactored.winning_min;
      system_combo.winning_total_min = systemRefactored.winning_total_min;
      system_combo.winning_max = systemRefactored.winning_max;
      system_combo.winning_total_max = systemRefactored.winning_total_max;
      system_combo.bonus_min = systemRefactored.bonus_min;
      system_combo.bonus_max = systemRefactored.bonus_max;
      system_combo.winning_all = systemRefactored.winning_all;
      system_combo.valid_combinations = systemRefactored.valid_combinations;
      if (systemRefactored.valid_combinations == 0) {
        system_combo.amount = 0;
        system_combo.checked = false;
        system_combo.totalAmount = 0;
      }

      resolve(system_combo);
    }
  });
}

async function refactorSystemParts(
  comboArray,
  amount,
  cartSettings,
  bonusRules,
  multi,
  context
) {
  return new Promise(async (resolve, reject) => {
    try {
      const combinations = comboArray.length;

      const promise = [];
      forEachLodash(comboArray, betOdds => {
        promise.push(
          refactorComboArray(betOdds, amount, cartSettings, bonusRules, context)
        );
      });

      Promise.all(promise).then(async refactoredComboArray => {
        const bonus_min = await minBy(refactoredComboArray, function (o) {
          return o.bonus;
        });
        const bonus_max = maxBy(refactoredComboArray, function (o) {
          return o.bonus;
        });

        const winning_min = await minBy(refactoredComboArray, function (o) {
          return o.winning;
        });
        const winning_max = await maxBy(refactoredComboArray, function (o) {
          return o.winning;
        });

        const winning_total_min = await minBy(
          refactoredComboArray,
          function (o) {
            return o.winning_total;
          }
        );
        const winning_total_max = await maxBy(
          refactoredComboArray,
          function (o) {
            return o.winning_total;
          }
        );

        const winning_all = await sumBy(refactoredComboArray, function (o) {
          return o.winning_total;
        });

        const valid_combinations = await countBy(
          refactoredComboArray,
          'multiplicity_check'
        );

        resolve({
          winning_all: winning_all ? roundLodash(winning_all, 2) : 0.0,
          winning_min: winning_min ? winning_min.winning : 0.0,
          winning_total_min: winning_total_min
            ? winning_total_min.winning_total
            : 0.0,
          bonus_min: bonus_min ? bonus_min.bonus : 0.0,
          bonus_max: bonus_max ? bonus_max.bonus : 0.0,
          winning_max: winning_max ? winning_max.winning : 0.0,
          winning_total_max: winning_total_max
            ? winning_total_max.winning_total
            : 0.0,
          totalAmount: roundLodash(amount * valid_combinations.true, 2),
          valid_combinations: valid_combinations.true
            ? valid_combinations.true
            : 0,
          refactoredComboArray: refactoredComboArray
        });
      });
    } catch (e) {
      console.log(e.message);
      console.log(e.stack);
    }
  });
}

async function refactorComboArray(
  betOdds,
  amount,
  cartSettings,
  bonusRules,
  context
) {
  return new Promise(async (resolve, reject) => {
    const bet = {};
    bet.amount = amount;
    bet.context = context;

    bet.odds = betOdds;
    bet.multiplicity_check = true;

    forEachLodash(bet.odds, odd => {
      if (
        !(
          betOdds.length >= +odd.multiplicity_min &&
          betOdds.length <= +odd.multiplicity_max
        )
      ) {
        bet.multiplicity_check = false;
      }
    });

    if (bet.multiplicity_check) {
      bet.odds_total = await getOddsTotal(betOdds);
      bet.multiplicity = betOdds.length;

      bet.winning = roundLodash(bet.amount * bet.odds_total, 2);

      const bonusDetail = await getBonus(
        cartSettings,
        bet,
        bet.multiplicity,
        bonusRules
      );

      if (bonusDetail.percentage > 0.0 && bonusDetail.oddsTotal > 0.0) {
        bet.bonus_percentage = +bonusDetail.percentage;
        bet.bonus = roundLodash(
          (bonusDetail.oddsTotal / 100) * +bonusDetail.percentage * bet.amount,
          2
        );
      } else {
        bet.bonus_percentage = 0.0;
        bet.bonus = 0.0;
      }

      bet.winning_total = roundLodash(bet.winning + bet.bonus, 2);
      bet.profit = roundLodash(bet.winning_total - bet.amount, 2);

      // Switch off for Performance
      bet.odds = [];

      resolve(bet);
    } else {
      resolve({});
    }
  });
}

async function getSystemTotalAmount(system_combo_detail) {
  return new Promise(async (resolve, reject) => {
    const system_combo = await filter(system_combo_detail, function (o) {
      return o.valid_combinations > 0 && o.checked == true;
    });

    const amount_system = sumBy(system_combo, 'totalAmount');
    const winning_min = minBy(system_combo, 'winning_min');
    const winning_max = sumBy(system_combo, 'winning_max');
    const winning_total_max = sumBy(system_combo, 'winning_total_max');
    const winning_total_min = minBy(system_combo, 'winning_total_min');
    const bonus_min = minBy(system_combo, 'bonus_min');
    const bonus_max = sumBy(system_combo, 'bonus_max');
    const winning_all = sumBy(system_combo, 'winning_all');
    const valid_combinations_all = sumBy(
      system_combo_detail,
      'valid_combinations'
    );

    const bonus_max_final = bonus_max ? roundLodash(bonus_max, 2) : 0.0;
    resolve({
      amount_system: amount_system ? roundLodash(amount_system, 2) : 0.0,
      winning_min: winning_min ? roundLodash(winning_min.winning_min, 2) : 0.0,
      winning_max: winning_max ? roundLodash(winning_max, 2) : 0.0,
      winning_total_max: winning_total_max
        ? roundLodash(winning_total_max, 2)
        : 0.0,
      winning_total_min: winning_total_min
        ? roundLodash(winning_total_min.winning_min, 2)
        : 0.0,
      bonus_min: bonus_min ? roundLodash(bonus_min.bonus_min, 2) : 0.0,
      bonus_max: bonus_max_final,
      winning_all: winning_all
        ? roundLodash(winning_all - bonus_max_final, 2)
        : 0.0,
      winning_all_total: winning_all ? roundLodash(winning_all, 2) : 0.0,
      valid_combinations_all: valid_combinations_all
    });
  });
}

async function setAmountSystemComboDetail(system_combo_detail, amount) {
  return new Promise(async (resolve, reject) => {
    for (let i = 0; i < system_combo_detail.length; i++) {
      if (system_combo_detail[i].checked) {
        system_combo_detail[i].amount = amount;
      } else {
        system_combo_detail[i].amount = 0.0;
      }
    }

    resolve(system_combo_detail);
  });
}

async function calcCombin(n, k) {
  return new Promise(async (resolve, reject) => {
    const num = await factorial(n);
    const den = (await factorial(k)) * (await factorial(n - k));
    resolve(num / den);
  });
}

async function factorial(number) {
  return new Promise(async (resolve, reject) => {
    let result = 1;

    if (number < 0) {
      return NaN;
    } else {
      for (let i = number; i > 0; i--) {
        result *= i;
      }
    }

    resolve(result);
  });
}

export default {
  getCartType,
  getCartContext,
  getOddsTotal,
  getBonus,
  resetBetAmount,
  resetBetIntegralOrSystem,
  getOddsTotalMinMax,
  getIntegralParts,
  refactorIntegralParts,
  getSystemComboDetail,
  setAmountSystemComboDetail,
  refactorSystemBet,
  getSystemTotalAmount
};
